<div class="table-header" [ngClass]="{'p-0': widgetMode}">
  <h3 *ngIf="!widgetMode">{{ 'view_translations.' +title | translate }} <span>({{ campaignsListLength }})</span></h3>
  <div class="option-buttons" *ngIf="!widgetMode">
    <app-sort-dropdown
      [sortValues]="sortDropdownValues"
      [choosenSortValue]="choosenSortValue"
      (emitChosenValue)="sortValueHandler($event)"
      [sortDropdownClass]="'greyBackground'">
    </app-sort-dropdown>
    <app-manage-columns-btn [detailsLayout]="detailsLayout" [tableTitle]="title ?? ''"></app-manage-columns-btn>
    <button *ngIf="isExpandable" class="btn switch-btn">
      <nb-icon
        icon="layout-table-thin"
        pack="icomoon"
        class="switch-icon global-transition"
        (click)="isDetailsLayoutHandler()"
        [ngClass]="{'active' : !detailsLayout}"></nb-icon>
      <nb-icon
        icon="layout-table-thick"
        pack="icomoon"
        class="switch-icon global-transition"
        (click)="isDetailsLayoutHandler()"
        [ngClass]="{'active' : detailsLayout}"></nb-icon>
    </button>
  </div>
  <div class="appiled-filters" *ngIf="Object.keys(appliedFiltersBar).length">
    <app-filters-bar [appliedFiltersBar]="appliedFiltersBar"></app-filters-bar>
  </div>
</div>
